import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { type BoxData } from '../../lib/types';
import { HeaderWithDescription } from '../HeaderWithDescription';
import { BoxCard } from '../BoxCard';

export function BoxCardList(props: {
  readonly boxes: BoxData[];
  readonly title: string;
  readonly description: string;
  readonly id?: string;
  readonly imageUrl?: string;
  readonly onOpenBox: (boxUrl: string) => void;
}) {
  return (
    <>
      <HeaderWithDescription
        id={props.id}
        title={props.title}
        description={props.description}
        className="my-5"
        imageUrl={props.imageUrl}
      />
      <Row xs={1} md={2} lg={4} className="g-4">
        {props.boxes.map((box) => (
          <Col key={box.id} className="px-1 d-flex justify-content-center">
            <BoxCard
              box={box}
              onClick={() => {
                props.onOpenBox(box.url);
              }}
            />
          </Col>
        ))}
      </Row>
    </>
  );
}
